
import notify from 'devextreme/ui/notify';
import { eventService } from './EventService';

class ToastService {
    private _time: number = 5000;

    get time(){
        return this._time;
    }

    set time(time: number){
        this._time = time;
    }

    public error(text: string){
        notify(text, 'error', this._time+10000);
    }

    public warning(text: string){
        notify(text, 'warning', this._time+10000);
    }

    public info(text: string){
        notify(text, 'info', this._time);
    }

    public success(text: string){
        notify(text, 'success', this._time);
    }

    public initEventListener(){
        eventService.on('toast-message', (message: any) => {
            if(message && message.Message && message.Level){
                notify(message.Message, message.Level, this._time);
            }            
        });
    }
}

export const toastService = new ToastService();